<template>
  <v-app id="inspire">
  <section class="loginWrap">
    <div>
      <figure class="loginHeader">
        <img src="/static/logo-w.svg" alt="ウィズム">
      </figure>
      <section class="loginContainer">
        <p class="subheading">
          with + mをご利用いただきありがとうございます。<br>
          大変申し訳ありませんが、このサイトはInternet Explorerに対応しておりません。<br>
          大変お手数ではありますが、下記よりGoogle ChromeかFirefoxをインストールの上ご利用をお願いいたします。
        </p>
        <div class="text-xs-center">
          <v-btn color="info" dark large target="_brank" href="https://www.google.co.jp/chrome/?brand=CHBD&gclid=Cj0KCQiA6JjgBRDbARIsANfu58HGbP9pQbUqE_aA8EkrlZJhQ0QkGHWhfgY6B_m7xnDOzZ8cxyHo3IMaAgs0EALw_wcB&gclsrc=aw.ds">Google Chrome</v-btn>
          <v-btn color="primary" dark large target="_brank" href="https://www.mozilla.org/ja/firefox/new/">Firefox</v-btn>
        </div>
      </section>
    </div>
  </section>
  </v-app>
</template>

<script>
export default {
  name: 'Msie'
}
</script>

<style lang="scss" scoped="">
.loginWrap {
  background: #fff url(~/static/login_main.jpg) no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100vh;
  text-align: center;
  box-sizing: border-box;
  padding-top: 20%;
}
.loginHeader {
  width: 250px;
  height: auto;
  margin: 0 auto 3rem;
}
.loginContainer {
  margin: 0 auto;
  text-align: left;
  max-width: 650px;
  padding: 20px;
  border: 2px solid #15c06a;
  background-color: rgba(255,255,255,0.7);
}
</style>



// WEBPACK FOOTER //
// src/pages/Msie.vue